<div id="{{ programEnum }}">
  <div class="inscription-page">
    <section class="container">
      <div class="d-flex row align-items-center">
        <div><img [src]="'/content/images/home/logo-geracaoz.png'" alt="logo" class="logo-programa" /></div>
        <div class="flex-fill">
          <h3>{{ candidature?.name }}</h3>
          <small>{{ candidature?.institutionName }}</small>
        </div>
      </div>
      <hr />
      <div class="row">
        <div class="col">
          <span [innerHTML]="candidature?.synthesis"></span>
        </div>
      </div>
      <div class="row dates-label mt-2">
        <div class="col-4 text-white">Início</div>
        <div class="col-4 text-white">Fim</div>
        <div class="col-4 text-white">Local</div>
      </div>
      <div class="row dates-text">
        <div class="col-4 text-white">{{ candidature?.startDate | formatMediumDate }}</div>
        <div class="col-4 text-white">{{ candidature?.endDate | formatMediumDate }}</div>
        <div class="col-4 text-white">{{ getLocations() }}</div>
      </div>
      <hr class="text-white" />
      <div class="row">
        <div class="col-8">
          <h5>Tarefas Disponíveis</h5>
          <table class="align-items-center table table-flush table-responsive w-100">
            <thead class="thead-light">
              <tr>
                <th>Descrição</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let record of getTasks()">
                <td style="white-space: normal">{{ record.description }}</td>
                <td>
                  <fa-icon (click)="openTaskModal(record)" icon="plus-circle"></fa-icon>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-4">
          <h5>Localização da Ação</h5>
          <agm-map style="height: 300px" (mapReady)="mapReady($event)" [latitude]="mapLat" [longitude]="mapLng" [zoom]="zoom">
            <agm-marker *ngFor="let marker of markers" [latitude]="marker.lat" [longitude]="marker.lng" [title]="marker.title"></agm-marker>
          </agm-map>
        </div>
      </div>
      <hr />
      <div class="d-flex justify-content-between mt-4">
        <button (click)="back()" class="btn-pg btn-vermais"><fa-icon icon="angle-left"></fa-icon>&nbsp;Voltar</button>
        <button (click)="signIn()" *ngIf="candidature?.published === true" class="btn-pg btn-inscreve alternate-color">
          <fa-icon icon="check"></fa-icon>&nbsp;Inscrever-me
        </button>
        <button *ngIf="candidature?.published !== true" [disabled]="true" class="btn-pg btn-inscreve alternate-color">
          <fa-icon icon="times"></fa-icon>&nbsp;O período de inscrições não se encontra aberto
        </button>
      </div>
    </section>
  </div>
</div>
